import React, { useState, useEffect } from 'react'
import {
  Container,
  HeaderDiv,
  HeaderText,
  CloseDiv,
  ContentContainer,
  Section,
  SectionHeader,
  FormGrid,
  StyledFormGroup,
  MaintenanceServiceWrapper,
  NameGroup,
  PeriodicidadeGroup,
  DeleteButton,
  AddMaintenanceButton,
  CancelButton,
  SaveButton,
  ButtonContainer
} from './style'
import { BlurBackground } from '../../style'
import crosslight from '../../../../../assets/stock/FiltersHeader/cross.svg'
import plus from '../../../../../assets/certificates/AddParameter/blue-plus.svg'
import save from '../../../../../assets/certificates/AddParameter/save.svg'
import trash from '../../../../../assets/equipment/Tables/trash.svg'

interface NewVehicleModalProps {
  isOpen: boolean
  onClose: () => void
  onSave: (vehicleData: any) => Promise<boolean>
}

interface PeriodicMaintenanceData {
  id: number
  maintenanceName: string
  periodicityValue: number | ''
  periodicityUnit: string
}

const NewVehicleModal: React.FC<NewVehicleModalProps> = ({
  isOpen,
  onClose,
  onSave,
}) => {
  const [plate, setplate] = useState<string>('')
  const [model, setModel] = useState<string>('')
  const [year, setYear] = useState<number | ''>('')
  const [capacity, setcapacity] = useState<string>('')
  const [bodyType, setBodyType] = useState<string>('')
  const [restriction, setRestriction] = useState<string>('')
  const [isSaving, setIsSaving] = useState<boolean>(false)

  const [periodicMaintenances, setPeriodicMaintenances] = useState<
    PeriodicMaintenanceData[]
  >([
    {
      id: Date.now(),
      maintenanceName: '',
      periodicityValue: '',
      periodicityUnit: '',
    },
  ])

  useEffect(() => {
    if (!isOpen) {
      setplate('')
      setModel('')
      setYear('')
      setcapacity('')
      setBodyType('')
      setRestriction('')
      setPeriodicMaintenances([
        {
          id: Date.now(),
          maintenanceName: '',
          periodicityValue: '',
          periodicityUnit: '',
        },
      ])
      setIsSaving(false)
    }
  }, [isOpen])


  if (!isOpen) {
    return null
  }

  const handleAddMaintenance = () => {
    setPeriodicMaintenances([
      ...periodicMaintenances,
      {
        id: Date.now(),
        maintenanceName: '',
        periodicityValue: '',
        periodicityUnit: '',
      },
    ])
  }

  const handleDeleteMaintenance = (id: number) => {
    setPeriodicMaintenances(periodicMaintenances.filter((pm) => pm.id !== id))
  }

  const handleMaintenanceChange = (
    id: number,
    field: keyof PeriodicMaintenanceData,
    value: string | number,
  ) => {
    setPeriodicMaintenances(
      periodicMaintenances.map((pm) =>
        pm.id === id ? { ...pm, [field]: value } : pm,
      ),
    )
  }

  const handleSaveClick = async () => {
    if (isSaving) return

    if (!plate || !model || !year) {
      console.error('Por favor, preencha a Placa, Modelo e Ano.')
      return
    }

    setIsSaving(true)

    const vehicleData = {
      plate,
      model,
      year: Number(year),
      capacity,
      bodyType,
      restriction: restriction || null,
      periodicMaintenances: periodicMaintenances
        .filter(
          (pm) =>
            pm.maintenanceName || pm.periodicityValue || pm.periodicityUnit,
        )
        .map(({ id, ...rest }) => rest), 
    }

    const success = await onSave(vehicleData)

    setIsSaving(false)

    if (success) {
      onClose()
    }
  }

  return (
    <BlurBackground>
      <Container>
        <HeaderDiv>
          <HeaderText>Novo veículo</HeaderText>
          <CloseDiv onClick={onClose}>
            <img
              src={crosslight}
              alt='Close'
              style={{ width: '12px', height: '12px' }}
            />
          </CloseDiv>
        </HeaderDiv>

        <ContentContainer>
          <Section>
            <FormGrid cols={2}>
              <StyledFormGroup>
                <label htmlFor='placa'>Placa</label>
                <input
                  type='text'
                  id='placa'
                  placeholder='Digite aqui'
                  value={plate}
                  onChange={(e) => setplate(e.target.value)}
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <label htmlFor='modelo'>Modelo</label>
                <input
                  type='text'
                  id='modelo'
                  placeholder='Digite aqui'
                  value={model}
                  onChange={(e) => setModel(e.target.value)}
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <label htmlFor='ano'>Ano</label>
                <input
                  type='number'
                  id='ano'
                  placeholder='Digite aqui'
                  value={year}
                  onChange={(e) => setYear(parseInt(e.target.value) || '')}
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <label htmlFor='capacidadeCarga'>Capacidade de carga</label>
                <input
                  type='text'
                  id='capacidadeCarga'
                  placeholder='Digite aqui'
                  value={capacity}
                  onChange={(e) => setcapacity(e.target.value)}
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <label htmlFor='tamanhoCarroceria'>Tamanho da carroceria</label>
                <input
                  type='text'
                  id='tamanhoCarroceria'
                  placeholder='Digite aqui'
                  value={bodyType}
                  onChange={(e) => setBodyType(e.target.value)}
                />
              </StyledFormGroup>
              <StyledFormGroup>
                <label htmlFor='restricaoRodagem'>Restrição de rodagem</label>
                <input
                  type='text'
                  id='restricaoRodagem'
                  placeholder='Digite aqui'
                  value={restriction}
                  onChange={(e) => setRestriction(e.target.value)}
                />
              </StyledFormGroup>
            </FormGrid>
          </Section>

          <Section>
            <SectionHeader>Manutenção periódica</SectionHeader>
            {periodicMaintenances.map((pm, index) => (
              <MaintenanceServiceWrapper key={pm.id}>
                <NameGroup>
                  <label htmlFor={`manutencaoNome-${pm.id}`}>Nome</label>
                  <input
                    type='text'
                    id={`manutencaoNome-${pm.id}`}
                    placeholder='Digite aqui'
                    value={pm.maintenanceName}
                    onChange={(e) =>
                      handleMaintenanceChange(
                        pm.id,
                        'maintenanceName',
                        e.target.value,
                      )
                    }
                  />
                </NameGroup>
                <PeriodicidadeGroup>
                  <label>Periodicidade</label>
                  <div className='input-wrapper'>
                    <span className='prefix-text'>A cada</span>
                    <input
                      type='number'
                      placeholder='Digite aqui'
                      value={pm.periodicityValue}
                      onChange={(e) =>
                        handleMaintenanceChange(
                          pm.id,
                          'periodicityValue',
                          parseInt(e.target.value) || '',
                        )
                      }
                    />
                    <select
                      value={pm.periodicityUnit}
                      onChange={(e) =>
                        handleMaintenanceChange(
                          pm.id,
                          'periodicityUnit',
                          e.target.value,
                        )
                      }
                    >
                      <option value=''>Selecione</option>
                      <option value='m'>Metros</option>
                      <option value='km'>Quilômetros</option>
                    </select>
                  </div>
                </PeriodicidadeGroup>
                <DeleteButton onClick={() => handleDeleteMaintenance(pm.id)}>
                  <img src={trash} alt='Excluir' />
                </DeleteButton>
              </MaintenanceServiceWrapper>
            ))}
            <AddMaintenanceButton onClick={handleAddMaintenance}>
              <img src={plus} alt='Adicionar' style={{ marginRight: '8px' }} />{' '}
              Adicionar manutenção
            </AddMaintenanceButton>
          </Section>
        </ContentContainer>

        <ButtonContainer>
          <CancelButton type='button' onClick={onClose} disabled={isSaving}>
            Cancelar
          </CancelButton>
          <SaveButton type='button' onClick={handleSaveClick} disabled={isSaving}>
            <img src={save} alt='Salvar' style={{ marginRight: '8px' }} />
            {isSaving ? 'Salvando...' : 'Salvar veículo'}
          </SaveButton>
        </ButtonContainer>
      </Container>
    </BlurBackground>
  )
}

export default NewVehicleModal
